import { render } from "./InvoiceDepartmentChart.vue?vue&type=template&id=745dbc3a&scoped=true"
import script from "./InvoiceDepartmentChart.vue?vue&type=script&lang=js"
export * from "./InvoiceDepartmentChart.vue?vue&type=script&lang=js"

import "./InvoiceDepartmentChart.vue?vue&type=style&index=0&id=745dbc3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745dbc3a"]])

export default __exports__